import { useSelector } from 'react-redux';

import { useAppDispatch } from 'src/store';
import { fdeInboxTabs } from 'ts/enums';
import { actions, selectors } from '../index';

const useSetFdeInbox = () => {
  const dispatch = useAppDispatch();
  const { filters } = useSelector(selectors);

  const filtering = (filter?: string) => {
    dispatch(actions.filtering({ filter, page: 0, rowsPerPage: filters?.rowsPerPage }));
  };

  const sorting = (sort?: string) => {
    dispatch(actions.sorting({ sort, page: 0, rowsPerPage: filters?.rowsPerPage }));
  };

  const searching = (q?: string) => {
    dispatch(actions.search({ q, page: 0, rowsPerPage: filters?.rowsPerPage }));
  };

  const paginating = (page: number, rowsPerPage: number) => {
    dispatch(actions.pagination({ page, rowsPerPage }));
  };

  const setSelectedTab = (selectedTab: fdeInboxTabs) => {
    dispatch(actions.setSelectedTab(selectedTab));
  };

  const clearSearch = () => {
    dispatch(actions.clearSearch());
  };

  const clearAllFilters = () => {
    dispatch(actions.clearAllFilters());
  };

  return {
    filtering,
    sorting,
    searching,
    paginating,
    setSelectedTab,
    clearSearch,
    clearAllFilters
  };
};

export default useSetFdeInbox;
